import { BidProps } from "@/interfaces/bid_types";
import { SectionDivRow } from "./Components/SectionDivRow";
import { SectionDiv } from "./Components/SectionDiv";
import { BidCard } from "../Cards/BidCard";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

type BidSectionProps = {
    sorted_bids: BidProps[],
    isNewCard: (cardType: string, id: string) => boolean,
    markAsSeen: (cardType: string, id: string) => void
}

export function BidSection(
    { sorted_bids, isNewCard, markAsSeen }: BidSectionProps
) {
    const [isMini, setIsMini] = useState(false)

    const onMiniClick = () => {
        const newIsMini = !isMini
        setIsMini(newIsMini)
        localStorage.setItem('bid_section_mini', newIsMini.toString())
    }

    useEffect(() => {
        const storedMini = localStorage.getItem('bid_section_mini')
        if (storedMini) {
            setIsMini(storedMini === 'true')
        }
    }, [])
    return (
        <SectionDiv>
            <BidHeader isMini={isMini} onClick={onMiniClick} />

            <SectionDivRow>
                {sorted_bids.length > 0 ? sorted_bids.map((bid) => (
                    <BidCard
                        key={bid.bid_id}
                        bid={bid}
                        isNew={isNewCard('bid', bid.bid_id ?? '')}
                        isMini={isMini}
                        onView={() => markAsSeen('bid', bid.bid_id ?? '')} />
                ))
                    :
                    <h3>No Bids assigned to you</h3>}
            </SectionDivRow>
        </SectionDiv>
    );
}

function BidHeader({ isMini, onClick }: { isMini: boolean, onClick: () => void }) {
    return (
        <div className="flex flex-row justify-between items-center">
            <h3>My Bids:</h3>
            <MiniButton onClick={onClick} isMini={isMini} />
        </div>
    )
}

function MiniButton({ onClick, isMini }: { onClick: () => void, isMini: boolean }) {
    return (
        <Button onClick={onClick} variant="outline" className="text-xs">
            {isMini ? 'View All' : 'View Mini'}
        </Button>
    )
}